import { getStatus, isDisplayedStatus } from "./status";
import type { Place, PlaceType } from "../types";

export function getPlaces(placeType: PlaceType, places: Place[], now: Date): Place[] {
  const ids = new Set(placeType.placeIds);

  return places.filter((place) => {
    if (ids.has(place.id)) {
      const status = getStatus(place, now);

      return isDisplayedStatus(status);
    }

    return false;
  });
}

export function hasPlaces(placeType: PlaceType, places: Place[], now: Date): boolean {
  return getPlaces(placeType, places, now).length > 0;
}
